import {APPLICATION} from './constants';

export const rest = {
    [APPLICATION]: {
        url: '/v3.0/iam/apps',
        crud: true,
    },
};
